/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelVendor.ts                        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/vendor";

export class AutogenModelVendor<RowType extends ModelRow> extends Endpoint<RowType, RowVendorFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowVendor extends ModelRow<RowVendorFields> {
	constructor(values?: Partial<RowVendorFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowVendorFields {
	ach_batch_class_code: string;
	address1: string;
	address2: string;
	address3: string;
	ap_term_code_id: string;
	box_for_1099_total: string;
	category_id: string;
	city: string;
	comments: string;
	company_id: string;
	currency_type: string;
	discount_percent: number;
	division_code: string;
	email_address: string;
	email_summary: string;
	exp_allocation_id: string;
	fax: string;
	hold_payments: string;
	hold_purchases: string;
	id: string;
	is_active: string;
	legal_name: string;
	payment_method: string;
	phone: string;
	po_required: string;
	prev_code: string;
	print_1099: string;
	print_sep_checks: string;
	state: string;
	suppress_chk_detail: string;
	tax_id: string;
	tax_id_type: string;
	vendor_name: string;
	vm_part_update: string;
	website_url: string;
	wf_queue: number;
	zip_code: string;
}

